import {createContext, useState} from "react";

export const MediaContext = createContext(null);